import { makeQuery } from "utilities/makeQuery"
import { fetchApiJson } from "utilities/fetchApiJson"

/**
 * 
 * @param {{page?: number, perPage?: number, category?: string}} params 
 * @returns 
 */
export async function getCategoryBlogArticlesApi(params) {
  return await fetchApiJson(makeQuery('/api/blog-articles', params))
}
